import { useEffect, useState } from 'react';
// @ts-expect-error Untyped library
import ReactCodeMirror from 'react-codemirror';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import MediaBar from 'developer-docs-shared-components/components/endpoint/MediaBar';
import ResponseFooter from 'developer-docs-shared-components/components/endpoint/ResponseFooter';
import { CodeMirrorThemeNames } from 'developer-docs-shared-components/utils/CodeMirrorTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
  Used specifically for legacy/v1 API MDX docs. Meant to look similar to
  the Swagger generated example response sections.
*/
const EndpointExample = ({
  children: {
    props: {
      children
    }
  },
  type = 'response'
}) => {
  const [expanded, setExpanded] = useState(false);
  const [unencoded, setUnencoded] = useState('');
  useEffect(() => {
    const unencodedString = window.atob(children).trim();
    setUnencoded(unencodedString);
  }, [children]);
  return /*#__PURE__*/_jsxs("div", {
    className: "response-panel m-bottom-4",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "response-header",
      children: type === 'request' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.response.headers.request"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.response.headers.response"
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(MediaBar, {
        onCopyValue: () => {},
        value: unencoded,
        children: /*#__PURE__*/_jsx("div", {})
      })
    }), /*#__PURE__*/_jsx(ReactCodeMirror, {
      height: expanded ? 'auto' : '400px',
      width: "100%",
      lineWrapping: true,
      mode: 'application/json',
      readOnly: true,
      theme: CodeMirrorThemeNames.DARK
      // Only show line numbers if there is more than one?
      ,
      lineNumbers: true,
      value: unencoded
    }), /*#__PURE__*/_jsx(ResponseFooter, {
      expanded: expanded,
      onClick: () => setExpanded(!expanded)
    })]
  });
};
export default EndpointExample;